import styled from 'styled-components';

import { StyleColor } from '../../../utils/styles-constants';
import { ItemContextualMenu } from '../../ListItem/ActionButton/styles';
import { ListItemUnreadBadge } from '../../ListItem/styles';
import { DownloadStatus } from '../../ListItem/DownloadStatus/styles';

const Wrapper = styled('div')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 60px;
	padding: 10px 20px;
	background-color: ${StyleColor.Grey50};
	font-size: 13px;
	line-height: 20px;
	color: ${StyleColor.Grey700};
`;

const Label = styled('div')`
	display: flex;
	align-items: center;
	width: 100%;

	&:not(:only-child) {
		width: calc(100% - 100px);
		margin-right: 20px;
	}

	> span {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	> *:not(:first-child) {
		flex: 0 0 auto;
	}

	> span:first-of-type {
		margin-right: 4px;
	}

	> span:last-of-type {
		margin-left: 4px;
	}

	${ListItemUnreadBadge} {
		position: relative;
		top: 1px;
		left: 0;
		margin-left: 10px;
	}

	${DownloadStatus} svg {
		position: relative;
		top: -1px;
		vertical-align: middle;
	}
`;

const ActionsWrapper = styled('div')`
	display: flex;

	${ItemContextualMenu} {
		position: static;
		margin-right: 20px;
	}
`;

export {
	Wrapper,
	Label,
	ActionsWrapper,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CoverFlow/ItemInfo/styles.ts